import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const optionElementTemplate = htmlE`
  <option selected="true" value="${"value"}">${"label"}</option>
`;

export const dropdownOptionTemplate = htmlE`
  <p class="autocomplete-option" option-name="${"name"}">${"label"}</p>
`;

export const dropdownHelperTextTemplate = htmlE`
  <p class="helper-text">${"label"}</p>
`;

export const autoCompleteChip = htmlE`
  <span class="autocomplete-selected-option">
    <span value="${"value"}">${"label"}</span>
    <i class="icon-remove"></i>
  </span>
`;
